// frontend/src/services/api/modules/vets.js
import { API_URL } from '../config';
import { getAuthHeaders, fetchWrapper } from '../utils/fetchWrapper';

export const obtenerVeterinarios = async () => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/veterinarios`, {
      method: "GET",
      headers,
    });
    if (!resp.ok) {
      const errData = await resp.json().catch(() => ({}));
      return { error: errData.error || "Error al listar veterinarios" };
    }
    return await resp.json();
  } catch (error) {
    console.error("Error en obtenerVeterinarios:", error);
    return { error: "Error de conexión con el servidor" };
  }
};

export const crearVeterinario = async (data) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/veterinarios`, {
      method: "POST",
      headers,
      body: JSON.stringify(data),
    });
    const result = await resp.json();
    if (!resp.ok) {
      return { error: result.error || "Error al crear veterinario" };
    }
    return result;
  } catch (error) {
    console.error("Error en crearVeterinario =>", error);
    return { error: "Error de conexión con el servidor" };
  }
};

export const actualizarVeterinario = async (vetId, data) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/veterinarios/${vetId}`, {
      method: "PATCH",
      headers,
      body: JSON.stringify(data),
    });
    const result = await resp.json();
    if (!resp.ok) {
      return { error: result.error || "Error al actualizar veterinario" };
    }
    return result;
  } catch (error) {
    console.error("Error en actualizarVeterinario =>", error);
    return { error: "Error de conexión con el servidor" };
  }
};

export const eliminarVeterinario = async (vetId) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/veterinarios/${vetId}`, {
      method: "DELETE",
      headers,
    });
    const result = await resp.json();
    if (!resp.ok) {
      return { error: result.error || "Error al eliminar veterinario" };
    }
    return result;
  } catch (error) {
    console.error("Error en eliminarVeterinario =>", error);
    return { error: "Error de conexión con el servidor" };
  }
};

export const reInvitarVeterinario = async (vetId) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/veterinarios/${vetId}`, {
      method: "PATCH",
      headers,
      body: JSON.stringify({ estatus: "pendiente" }),
    });
    const result = await resp.json();
    if (!resp.ok) {
      return { error: result.error || "Error al re-invitar veterinario" };
    }
    return result;
  } catch (error) {
    console.error("Error en reInvitarVeterinario =>", error);
    return { error: "Error de conexión con el servidor" };
  }
};

export const obtenerVeterinarioPorToken = async (token) => {
  try {
    const resp = await fetchWrapper(
      `${API_URL}/api/veterinarios/loginMagic?token=${encodeURIComponent(token)}`
    );
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error verificando veterinario" };
    }
    return data;
  } catch (err) {
    console.error("Error en obtenerVeterinarioPorToken =>", err);
    return { error: "Error de conexión" };
  }
};

export const aceptarInvitacionVet = async (vetId) => {
  try {
    const resp = await fetchWrapper(`${API_URL}/api/veterinarios/${vetId}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ estado: "verificado" })
    });
    const data = await resp.json();
    if (!resp.ok) return { error: data.error || "Error al aceptar invitación" };
    return data;
  } catch (err) {
    console.error("Error en aceptarInvitacionVet =>", err);
    return { error: "Error de conexión" };
  }
};

/**
 * @deprecated MODELO LEGACY (pre-2026)
 * Usar eliminarVeterinarioDeUsuario(userId, vetId) en su lugar.
 * El nuevo endpoint también cancela citas futuras automáticamente.
 */
export const desasociarVeterinario = async (vetId) => {
  console.warn('[DEPRECATED] desasociarVeterinario: Usar eliminarVeterinarioDeUsuario(userId, vetId)');
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/veterinarios/${vetId}/desasociar`, {
      method: "POST",
      headers,
    });
    const result = await resp.json();
    if (!resp.ok) {
      return { error: result.error || "Error al desasociar veterinario" };
    }
    return result;
  } catch (error) {
    console.error("Error en desasociarVeterinario =>", error);
    return { error: "Error de conexión con el servidor" };
  }
};

export const getVeterinariosByIds = async (idsString) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/veterinarios/byIds?ids=${encodeURIComponent(idsString)}`, {
      headers
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al obtener vets por IDs" };
    }
    return data;
  } catch (error) {
    console.error("Error en getVeterinariosByIds =>", error);
    return { error: "Error de conexión con el servidor" };
  }
};

export const solicitarNuevoEnlaceVet = async (correo) => {
  try {
    const resp = await fetchWrapper(`${API_URL}/api/veterinarios/solicitarLink`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ correo }),
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al solicitar nuevo enlace vet" };
    }
    return data;
  } catch (error) {
    console.error("Error en solicitarNuevoEnlaceVet =>", error);
    return { error: "Error de conexión." };
  }
};

export const getPacientesDeVet = async (vetId, letter = "") => {
  try {
    let url = `${API_URL}/api/veterinarios/${encodeURIComponent(vetId)}/pacientes`;
    if (letter) {
      url += `?letra=${encodeURIComponent(letter)}`;
    }
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(url, {
      method: "GET",
      headers,
    });
    const result = await resp.json();
    if (!resp.ok) {
      return { error: result.error || "Error al obtener pacientes" };
    }
    return result;
  } catch (error) {
    console.error("Error en getPacientesDeVet =>", error);
    return { error: "Error de conexión con el servidor" };
  }
};

export const getDisponibilidadVet = async (vetId) => {
  const headers = await getAuthHeaders();
  const resp = await fetchWrapper(`${API_URL}/api/veterinarios/${vetId}/disponibilidad`, {
    headers
  });
  if (!resp.ok) {
    const errData = await resp.json().catch(() => ({}));
    throw new Error(errData.error || "Error al cargar disponibilidad");
  }
  const data = await resp.json();
  return data.data || [];
};

export const crearBloqueDisponibilidad = async (vetId, bloqueData) => {
  const headers = await getAuthHeaders();
  const resp = await fetchWrapper(`${API_URL}/api/veterinarios/${vetId}/disponibilidad`, {
    method: "POST",
    headers,
    body: JSON.stringify(bloqueData),
  });
  if (!resp.ok) {
    const errData = await resp.json().catch(() => ({}));
    throw new Error(errData.error || "Error al crear disponibilidad");
  }
  const data = await resp.json();
  return data.data;
};

export const eliminarBloqueDisponibilidad = async (vetId, docId) => {
  const headers = await getAuthHeaders();
  const resp = await fetchWrapper(`${API_URL}/api/veterinarios/${vetId}/disponibilidad/${docId}`, {
    method: "DELETE",
    headers
  });
  if (!resp.ok) {
    const errData = await resp.json().catch(() => ({}));
    throw new Error(errData.error || "Error al eliminar disponibilidad");
  }
  return true;
};

// =============================================
// Configuración de disponibilidad (Calendly-style)
// =============================================

export const getDisponibilidadConfig = async (vetId) => {
  const headers = await getAuthHeaders();
  const resp = await fetchWrapper(`${API_URL}/api/veterinarios/${vetId}/disponibilidad-config`, {
    headers
  });
  if (!resp.ok) {
    const errData = await resp.json().catch(() => ({}));
    throw new Error(errData.error || "Error al cargar configuración");
  }
  const data = await resp.json();
  return data.data;
};

export const guardarDisponibilidadConfig = async (vetId, config) => {
  const headers = await getAuthHeaders();
  const resp = await fetchWrapper(`${API_URL}/api/veterinarios/${vetId}/disponibilidad-config`, {
    method: "POST",
    headers,
    body: JSON.stringify(config),
  });
  if (!resp.ok) {
    const errData = await resp.json().catch(() => ({}));
    throw new Error(errData.error || "Error al guardar configuración");
  }
  const data = await resp.json();
  return data.data;
};

export const getCitasDeVet = async (vetId) => {
  const headers = await getAuthHeaders();
  const resp = await fetchWrapper(`${API_URL}/api/veterinarios/${vetId}/citas`, {
    headers
  });
  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.error || "Error al obtener citas");
  }
  const data = await resp.json();
  return data.data || [];
};

export const confirmarCita = async (vetId, citaId) => {
  const headers = await getAuthHeaders();
  const resp = await fetchWrapper(`${API_URL}/api/veterinarios/${vetId}/citas/${citaId}/confirmar`, {
    method: "PATCH",
    headers
  });
  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.error || "Error al confirmar cita");
  }
  const data = await resp.json();
  return data.data; // Retorna { ...cita, snapshotCartillaUrl, snapshotExpedienteUrl }
};

export const rechazarCita = async (vetId, citaId) => {
  const headers = await getAuthHeaders();
  const resp = await fetchWrapper(`${API_URL}/api/veterinarios/${vetId}/citas/${citaId}/rechazar`, {
    method: "PATCH",
    headers
  });
  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.error || "Error al rechazar la cita");
  }
};

export const marcarNoAsistio = async (vetId, citaId) => {
  const headers = await getAuthHeaders();
  const resp = await fetchWrapper(`${API_URL}/api/veterinarios/${vetId}/citas/${citaId}/no-asistio`, {
    method: "PATCH",
    headers
  });
  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.error || "Error al marcar la cita como no asistio");
  }
  return await resp.json();
};

export const crearCitaDeVet = async (vetId, citaData) => {
  const headers = await getAuthHeaders();
  const resp = await fetchWrapper(`${API_URL}/api/veterinarios/${vetId}/citas`, {
    method: "POST",
    headers,
    body: JSON.stringify(citaData),
  });
  if (!resp.ok) {
    const errData = await resp.json().catch(() => ({}));
    throw new Error(errData.error || "Error al crear cita");
  }
  const data = await resp.json();
  return data.data || {};
};

export const cancelarCitaDeVet = async (vetId, citaId) => {
  const headers = await getAuthHeaders();
  const resp = await fetchWrapper(`${API_URL}/api/veterinarios/${vetId}/citas/${citaId}`, {
    method: "DELETE",
    headers,
  });
  if (!resp.ok) {
    const errData = await resp.json().catch(() => ({}));
    throw new Error(errData.error || "Error al cancelar cita");
  }
  return { success: true };
};

/**
 * Obtiene los veterinarios vinculados al usuario.
 * NOTA: Ahora usa el modelo 2026 que consulta Usuarios/{userId}/veterinarios[]
 * @param {string} userId - ID del usuario
 * @returns {Array} Array de veterinarios
 */
export const obtenerMisVeterinarios = async (userId) => {
  const headers = await getAuthHeaders();
  const resp = await fetchWrapper(`${API_URL}/api/veterinarios/misVeterinarios/${userId}`, {
    headers
  });
  if (!resp.ok) {
    const errData = await resp.json().catch(() => ({}));
    throw new Error(errData.error || "Error al obtener veterinarios");
  }
  const data = await resp.json();
  return data.data || [];
};

// FUNCIONES ACTUALIZADAS PARA USAR :id EN LUGAR DE :objetoId
export const getExpedienteDeMascota = async (id) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${id}/expediente`, {
      headers
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al obtener expediente" };
    }
    return data;
  } catch (error) {
    console.error("Error getExpedienteDeMascota =>", error);
    return { error: "Error de conexión" };
  }
};

export const obtenerInfoMascota = async (id) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${id}/info`, {
      headers
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al obtener información de mascota" };
    }
    return data;
  } catch (error) {
    console.error("Error obtenerInfoMascota =>", error);
    return { error: "Error de conexión" };
  }
};

export const crearEntradaExpediente = async (id, entryData) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${id}/expediente`, {
      method: "POST",
      headers,
      body: JSON.stringify(entryData),
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al crear entrada expediente" };
    }
    return data;
  } catch (error) {
    console.error("Error crearEntradaExpediente =>", error);
    return { error: "Error de conexión" };
  }
};

export const actualizarEntradaExpediente = async (id, entryId, updates) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${id}/expediente/${entryId}`, {
      method: "PATCH",
      headers,
      body: JSON.stringify(updates),
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al actualizar entrada" };
    }
    return data;
  } catch (error) {
    console.error("Error actualizarEntradaExpediente =>", error);
    return { error: "Error de conexión" };
  }
};

export const eliminarEntradaExpediente = async (id, entryId) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${id}/expediente/${entryId}`, {
      method: "DELETE",
      headers
    });
    if (!resp.ok) {
      const data = await resp.json();
      return { error: data.error || "Error al eliminar entrada" };
    }
    return { message: "OK" };
  } catch (error) {
    console.error("Error eliminarEntradaExpediente =>", error);
    return { error: "Error de conexión" };
  }
};

/**
 * Anula una entrada del expediente (después de 24h)
 * @param {string} objetoId - ID de la mascota
 * @param {string} entryId - ID de la entrada a anular
 * @param {string} razon - Razón de la anulación (mínimo 10 caracteres)
 * @returns {Object} { success: true } o { error: string, razon: string }
 */
export const anularEntradaExpediente = async (objetoId, entryId, razon) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${objetoId}/expediente/${entryId}/anular`, {
      method: "POST",
      headers,
      body: JSON.stringify({ razon }),
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al anular entrada", razon: data.razon };
    }
    return data;
  } catch (error) {
    console.error("Error anularEntradaExpediente =>", error);
    return { error: "Error de conexión" };
  }
};

/**
 * Certifica una entrada del expediente (solo veterinarios, solo registros de propietarios)
 * @param {string} objetoId - ID de la mascota
 * @param {string} entryId - ID de la entrada a certificar
 * @returns {Object} { success: true } o { error: string, razon: string }
 */
export const certificarEntradaExpediente = async (objetoId, entryId) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${objetoId}/expediente/${entryId}/certificar`, {
      method: "POST",
      headers,
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al certificar entrada", razon: data.razon };
    }
    return data;
  } catch (error) {
    console.error("Error certificarEntradaExpediente =>", error);
    return { error: "Error de conexión" };
  }
};

// ============ PACIENTES EXTERNOS ============

export const crearPacienteExterno = async (vetId, pacienteData) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/veterinarios/${vetId}/pacientes`, {
      method: "POST",
      headers,
      body: JSON.stringify(pacienteData),
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al crear paciente" };
    }
    return data;
  } catch (error) {
    console.error("Error crearPacienteExterno =>", error);
    return { error: "Error de conexión" };
  }
};

export const actualizarPaciente = async (vetId, pacienteId, updates) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/veterinarios/${vetId}/pacientes/${pacienteId}`, {
      method: "PATCH",
      headers,
      body: JSON.stringify(updates),
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al actualizar paciente" };
    }
    return data;
  } catch (error) {
    console.error("Error actualizarPaciente =>", error);
    return { error: "Error de conexión" };
  }
};

export const eliminarPaciente = async (vetId, pacienteId) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/veterinarios/${vetId}/pacientes/${pacienteId}`, {
      method: "DELETE",
      headers,
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al eliminar paciente" };
    }
    return data;
  } catch (error) {
    console.error("Error eliminarPaciente =>", error);
    return { error: "Error de conexión" };
  }
};

// ============ VETERINARIOS A NIVEL USUARIO (NUEVO MODELO 2026) ============

/**
 * Obtiene los veterinarios vinculados al usuario con límites
 * @param {string} userId - ID del usuario
 * @returns {Object} { veterinarios, limites }
 */
export const obtenerVeterinariosDeUsuario = async (userId) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/usuarios/${userId}/veterinarios`, {
      method: "GET",
      headers,
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al obtener veterinarios" };
    }
    return data;
  } catch (error) {
    console.error("Error obtenerVeterinariosDeUsuario =>", error);
    return { error: "Error de conexión" };
  }
};

/**
 * Invita un veterinario a nivel de usuario (acceso a todas las mascotas Premium)
 * @param {string} userId - ID del usuario
 * @param {Object} vetData - Datos del veterinario { nombre, correo, telefono, etc. }
 * @returns {Object} { veterinario, limites, esReInvitacion }
 */
export const invitarVeterinarioAUsuario = async (userId, vetData) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/usuarios/${userId}/veterinarios`, {
      method: "POST",
      headers,
      body: JSON.stringify(vetData),
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al invitar veterinario" };
    }
    return data;
  } catch (error) {
    console.error("Error invitarVeterinarioAUsuario =>", error);
    return { error: "Error de conexión" };
  }
};

/**
 * Elimina un veterinario del usuario y cancela citas futuras
 * @param {string} userId - ID del usuario
 * @param {string} vetId - ID del veterinario
 * @returns {Object} { success, citasCanceladas }
 */
export const eliminarVeterinarioDeUsuario = async (userId, vetId) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/usuarios/${userId}/veterinarios/${vetId}`, {
      method: "DELETE",
      headers,
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al eliminar veterinario" };
    }
    return data;
  } catch (error) {
    console.error("Error eliminarVeterinarioDeUsuario =>", error);
    return { error: "Error de conexión" };
  }
};

// ============ COMPARTIR EXPEDIENTE CLÍNICO ============

/**
 * Obtiene o genera el token para compartir el expediente clínico
 * @param {string} objetoId - ID de la mascota
 * @returns {Object} { token, shareUrl, isNew }
 */
export const compartirExpediente = async (objetoId) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${objetoId}/expediente/compartir`, {
      method: "POST",
      headers,
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al generar link de compartir" };
    }
    return data;
  } catch (error) {
    console.error("Error compartirExpediente =>", error);
    return { error: "Error de conexión" };
  }
};

/**
 * Regenera el token de compartir expediente (invalida el anterior)
 * @param {string} objetoId - ID de la mascota
 * @returns {Object} { token, shareUrl, regeneratedAt }
 */
export const regenerarTokenExpediente = async (objetoId) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${objetoId}/expediente/regenerar-token`, {
      method: "POST",
      headers,
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al regenerar link" };
    }
    return data;
  } catch (error) {
    console.error("Error regenerarTokenExpediente =>", error);
    return { error: "Error de conexión" };
  }
};

/**
 * Desactiva el token de compartir expediente
 * @param {string} objetoId - ID de la mascota
 * @returns {Object} { success, message }
 */
export const desactivarCompartirExpediente = async (objetoId) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${objetoId}/expediente/compartir`, {
      method: "DELETE",
      headers,
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al desactivar link" };
    }
    return data;
  } catch (error) {
    console.error("Error desactivarCompartirExpediente =>", error);
    return { error: "Error de conexión" };
  }
};

/**
 * Obtiene los lugares de confianza configurados para el expediente
 * @param {string} objetoId - ID de la mascota
 * @returns {Object} { lugaresConfianza: Array }
 */
export const getLugaresConfianza = async (objetoId) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${objetoId}/expediente/lugares-confianza`, {
      method: "GET",
      headers,
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al obtener lugares de confianza" };
    }
    return data;
  } catch (error) {
    console.error("Error getLugaresConfianza =>", error);
    return { error: "Error de conexión" };
  }
};

/**
 * Actualiza los lugares de confianza para el expediente compartido
 * @param {string} objetoId - ID de la mascota
 * @param {Array} lugares - Array de lugares (máximo 4)
 * @returns {Object} { lugaresConfianza: Array, message: string }
 */
export const updateLugaresConfianza = async (objetoId, lugares) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${objetoId}/expediente/lugares-confianza`, {
      method: "PUT",
      headers: {
        ...headers,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ lugares })
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al actualizar lugares de confianza" };
    }
    return data;
  } catch (error) {
    console.error("Error updateLugaresConfianza =>", error);
    return { error: "Error de conexión" };
  }
};

/**
 * Exporta el expediente a PDF con las entradas seleccionadas
 * @param {string} objetoId - ID de la mascota
 * @param {string[]} entryIds - IDs de las entradas a incluir
 * @param {boolean} incluirDocumentos - Si incluir lista de documentos al final
 * @param {Array} lugaresConfianza - Lugares de confianza a incluir (máximo 4)
 * @returns {Promise<Blob|{error: string}>} Blob del PDF o error
 */
export const exportarExpedientePdf = async (objetoId, entryIds, incluirDocumentos = true, lugaresConfianza = []) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${objetoId}/expediente/export-pdf`, {
      method: "POST",
      headers: {
        ...headers,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ entryIds, incluirDocumentos, lugaresConfianza })
    });

    if (!resp.ok) {
      const data = await resp.json();
      return { error: data.error || "Error al exportar PDF" };
    }

    // Obtener el blob del PDF
    const blob = await resp.blob();
    return { blob };
  } catch (error) {
    console.error("Error exportarExpedientePdf =>", error);
    return { error: "Error de conexión" };
  }
};

/**
 * Exporta la Cartilla de Salud (vacunas y desparasitaciones) como PDF
 * @param {string} objetoId - ID de la mascota
 * @returns {Promise<Object>} Blob del PDF o error
 */
export const exportarCartillaPdf = async (objetoId) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${objetoId}/expediente/export-cartilla`, {
      method: "POST",
      headers: {
        ...headers,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({})
    });

    if (!resp.ok) {
      const data = await resp.json();
      return { error: data.error || "Error al exportar cartilla" };
    }

    const blob = await resp.blob();
    return { blob };
  } catch (error) {
    console.error("Error exportarCartillaPdf =>", error);
    return { error: "Error de conexion" };
  }
};

/**
 * Analiza una receta/documento con IA para extraer datos automáticamente
 * @param {string} objetoId - ID de la mascota
 * @param {File} file - Archivo de la receta (JPG, PNG o PDF)
 * @returns {Promise<Object>} Datos extraídos o error
 */
export const analizarRecetaConIA = async (objetoId, file) => {
  try {
    const headers = await getAuthHeaders();

    // Crear FormData para enviar el archivo
    const formData = new FormData();
    formData.append('receta', file);

    console.log('[analizarRecetaConIA] Enviando archivo:', {
      nombre: file.name,
      tipo: file.type,
      tamaño: `${(file.size / 1024).toFixed(2)} KB`,
      objetoId
    });

    // Remover Content-Type para que el navegador lo ponga con el boundary correcto
    const { 'Content-Type': _, ...headersWithoutContentType } = headers;

    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${objetoId}/expediente/analizar-receta`, {
      method: "POST",
      headers: headersWithoutContentType,
      body: formData
    });

    console.log('[analizarRecetaConIA] Respuesta recibida:', resp.status, resp.statusText);

    const data = await resp.json();

    if (!resp.ok) {
      return {
        success: false,
        error: data.error || 'ERROR',
        errorType: data.errorType || 'error',
        message: data.message || 'Error al analizar la receta',
        suggestions: data.suggestions || []
      };
    }

    return data;
  } catch (error) {
    console.error("Error analizarRecetaConIA =>", error);
    return {
      success: false,
      error: 'CONNECTION_ERROR',
      errorType: 'error',
      message: 'Error de conexión con el servidor. Por favor intenta de nuevo.'
    };
  }
};

// ============ VACUNAS (Cartilla de Vacunación) ============

/**
 * Obtiene todas las vacunas de una mascota
 * @param {string} objetoId - ID de la mascota
 * @returns {Promise<Object>} { data: vacunas[] } o { error }
 */
export const obtenerVacunasDeMascota = async (objetoId) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${objetoId}/vacunas`, {
      method: "GET",
      headers,
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al obtener vacunas" };
    }
    return data;
  } catch (error) {
    console.error("Error obtenerVacunasDeMascota =>", error);
    return { error: "Error de conexión" };
  }
};

/**
 * Crea una nueva vacuna en el registro
 * @param {string} objetoId - ID de la mascota
 * @param {Object} vacunaData - { fecha, nombre, laboratorio, lote, caducidad, proximaVacunacion }
 * @returns {Promise<Object>} { data: vacuna } o { error }
 */
export const crearVacuna = async (objetoId, vacunaData) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${objetoId}/vacunas`, {
      method: "POST",
      headers,
      body: JSON.stringify(vacunaData),
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al crear vacuna" };
    }
    return data;
  } catch (error) {
    console.error("Error crearVacuna =>", error);
    return { error: "Error de conexión" };
  }
};

/**
 * Actualiza una vacuna existente
 * @param {string} objetoId - ID de la mascota
 * @param {string} vacunaId - ID de la vacuna
 * @param {Object} updates - Campos a actualizar
 * @returns {Promise<Object>} { data: vacuna } o { error }
 */
export const actualizarVacuna = async (objetoId, vacunaId, updates) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${objetoId}/vacunas/${vacunaId}`, {
      method: "PATCH",
      headers,
      body: JSON.stringify(updates),
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al actualizar vacuna" };
    }
    return data;
  } catch (error) {
    console.error("Error actualizarVacuna =>", error);
    return { error: "Error de conexión" };
  }
};

/**
 * Elimina una vacuna del registro
 * @param {string} objetoId - ID de la mascota
 * @param {string} vacunaId - ID de la vacuna
 * @returns {Promise<Object>} { message } o { error }
 */
export const eliminarVacuna = async (objetoId, vacunaId) => {
  try {
    const headers = await getAuthHeaders();
    console.log('[eliminarVacuna] Calling DELETE for:', { objetoId, vacunaId });

    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${objetoId}/vacunas/${vacunaId}`, {
      method: "DELETE",
      headers,
    });

    console.log('[eliminarVacuna] Response status:', resp.status);

    if (!resp.ok) {
      const data = await resp.json();
      console.error('[eliminarVacuna] Error response:', data);
      return { error: data.error || "Error al eliminar vacuna" };
    }

    const data = await resp.json();
    console.log('[eliminarVacuna] Success:', data);
    return { success: true, message: data.message || "OK" };
  } catch (error) {
    console.error("Error eliminarVacuna =>", error);
    return { error: "Error de conexión" };
  }
};

/**
 * Verifica si hay vacunas duplicadas antes de importar
 * @param {string} objetoId - ID de la mascota
 * @param {Array} vacunas - Lista de vacunas a verificar
 * @returns {Promise<Object>} { data: vacunasConEstado[] } o { error }
 */
export const verificarDuplicadosVacunas = async (objetoId, vacunas) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${objetoId}/vacunas/verificar-duplicados`, {
      method: "POST",
      headers,
      body: JSON.stringify({ vacunas }),
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al verificar duplicados" };
    }
    return data;
  } catch (error) {
    console.error("Error verificarDuplicadosVacunas =>", error);
    return { error: "Error de conexión" };
  }
};

/**
 * Importa múltiples vacunas en lote (después de revisión del usuario)
 * @param {string} objetoId - ID de la mascota
 * @param {Array} vacunas - Lista de vacunas a importar
 * @returns {Promise<Object>} { data: vacunasCreadas[], skipped: vacunasOmitidas[], message }
 */
export const importarVacunasLote = async (objetoId, vacunas) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${objetoId}/vacunas/importar-lote`, {
      method: "POST",
      headers,
      body: JSON.stringify({ vacunas }),
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al importar vacunas" };
    }
    return data;
  } catch (error) {
    console.error("Error importarVacunasLote =>", error);
    return { error: "Error de conexión" };
  }
};

/**
 * Analiza una foto de cartilla de vacunación con IA
 * @param {string} objetoId - ID de la mascota
 * @param {File} file - Archivo de la cartilla (JPG, PNG o PDF)
 * @returns {Promise<Object>} { success, vacunas[], warnings[] } o error
 */
export const analizarCartillaConIA = async (objetoId, file) => {
  try {
    const headers = await getAuthHeaders();

    const formData = new FormData();
    formData.append('cartilla', file);

    console.log('[analizarCartillaConIA] Enviando archivo:', {
      nombre: file.name,
      tipo: file.type,
      tamaño: `${(file.size / 1024).toFixed(2)} KB`,
      objetoId
    });

    const { 'Content-Type': _, ...headersWithoutContentType } = headers;

    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${objetoId}/vacunas/analizar-cartilla`, {
      method: "POST",
      headers: headersWithoutContentType,
      body: formData
    });

    const data = await resp.json();

    if (!resp.ok) {
      return {
        success: false,
        error: data.error || 'ERROR',
        errorType: data.errorType || 'error',
        message: data.message || 'Error al analizar la cartilla',
        suggestions: data.suggestions || [],
        resetInMinutes: data.resetInMinutes,
        limit: data.limit
      };
    }

    return data;
  } catch (error) {
    console.error("Error analizarCartillaConIA =>", error);
    return {
      success: false,
      error: 'CONNECTION_ERROR',
      errorType: 'error',
      message: 'Error de conexión con el servidor.'
    };
  }
};

/**
 * Elimina todas las vacunas importadas (no asociadas a eventos médicos)
 * @param {string} objetoId - ID de la mascota
 * @returns {Promise<Object>} { success, deleted, message }
 */
export const eliminarVacunasImportadas = async (objetoId) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${objetoId}/vacunas/importadas`, {
      method: "DELETE",
      headers,
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al eliminar vacunas importadas" };
    }
    return data;
  } catch (error) {
    console.error("Error eliminarVacunasImportadas =>", error);
    return { error: "Error de conexión" };
  }
};

// ============ DESPARASITACIONES (Subcolección independiente) ============

/**
 * Obtiene todas las desparasitaciones de una mascota
 * @param {string} objetoId - ID de la mascota
 * @returns {Promise<Object>} { data: desparasitaciones[] } o { error }
 */
export const obtenerDesparasitacionesDeMascota = async (objetoId) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${objetoId}/desparasitaciones`, {
      method: "GET",
      headers,
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al obtener desparasitaciones" };
    }
    return data;
  } catch (error) {
    console.error("Error obtenerDesparasitacionesDeMascota =>", error);
    return { error: "Error de conexión" };
  }
};

/**
 * Crea una nueva desparasitación
 * @param {string} objetoId - ID de la mascota
 * @param {Object} despData - { fecha, producto, tipoDesparasitacion, aplicadoEn, etc. }
 * @returns {Promise<Object>} { data: desparasitacion } o { error }
 */
export const crearDesparasitacion = async (objetoId, despData) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${objetoId}/desparasitaciones`, {
      method: "POST",
      headers,
      body: JSON.stringify(despData),
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al crear desparasitación" };
    }
    return data;
  } catch (error) {
    console.error("Error crearDesparasitacion =>", error);
    return { error: "Error de conexión" };
  }
};

/**
 * Actualiza una desparasitación existente
 * @param {string} objetoId - ID de la mascota
 * @param {string} desparasitacionId - ID de la desparasitación
 * @param {Object} updates - Campos a actualizar
 * @returns {Promise<Object>} { data: desparasitacion } o { error }
 */
export const actualizarDesparasitacion = async (objetoId, desparasitacionId, updates) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${objetoId}/desparasitaciones/${desparasitacionId}`, {
      method: "PATCH",
      headers,
      body: JSON.stringify(updates),
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al actualizar desparasitación" };
    }
    return data;
  } catch (error) {
    console.error("Error actualizarDesparasitacion =>", error);
    return { error: "Error de conexión" };
  }
};

/**
 * Elimina una desparasitación
 * @param {string} objetoId - ID de la mascota
 * @param {string} desparasitacionId - ID de la desparasitación
 * @returns {Promise<Object>} { success, message } o { error }
 */
export const eliminarDesparasitacion = async (objetoId, desparasitacionId) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${objetoId}/desparasitaciones/${desparasitacionId}`, {
      method: "DELETE",
      headers,
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al eliminar desparasitación" };
    }
    return { success: true, message: data.message || "OK" };
  } catch (error) {
    console.error("Error eliminarDesparasitacion =>", error);
    return { error: "Error de conexión" };
  }
};

/**
 * Importa múltiples desparasitaciones en lote
 * @param {string} objetoId - ID de la mascota
 * @param {Array} desparasitaciones - Lista de desparasitaciones a importar
 * @returns {Promise<Object>} { data, skipped, message } o { error }
 */
export const importarDesparasitacionesLote = async (objetoId, desparasitaciones) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/mascotas/${objetoId}/desparasitaciones/importar-lote`, {
      method: "POST",
      headers,
      body: JSON.stringify({ desparasitaciones }),
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al importar desparasitaciones" };
    }
    return data;
  } catch (error) {
    console.error("Error importarDesparasitacionesLote =>", error);
    return { error: "Error de conexión" };
  }
};

// ============ PERFIL PROFESIONAL DEL VETERINARIO ============

/**
 * Obtiene el perfil profesional del veterinario autenticado
 * @returns {Object} { data: PerfilProfesional } o { error: string }
 */
export const obtenerPerfilProfesional = async () => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/veterinarios/perfil`, {
      method: "GET",
      headers,
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al obtener perfil profesional" };
    }
    return data;
  } catch (error) {
    console.error("Error obtenerPerfilProfesional =>", error);
    return { error: "Error de conexión" };
  }
};

/**
 * Crea o actualiza el perfil profesional del veterinario autenticado
 * @param {Object} perfilData - Datos del perfil profesional
 * @param {string} perfilData.nombreCompleto - Nombre completo (obligatorio)
 * @param {string} perfilData.cedulaProfesional - Cédula profesional (obligatorio)
 * @param {string} perfilData.nombreClinica - Nombre de la clínica (obligatorio)
 * @param {string} [perfilData.universidad] - Universidad (opcional)
 * @param {string} [perfilData.especialidad] - Especialidad (opcional)
 * @param {string} [perfilData.direccion] - Dirección (opcional)
 * @param {string} [perfilData.ciudad] - Ciudad (opcional)
 * @param {string} [perfilData.telefono] - Teléfono (opcional)
 * @param {string} [perfilData.email] - Email (opcional)
 * @returns {Object} { data: PerfilActualizado, message: string } o { error: string }
 */
export const guardarPerfilProfesional = async (perfilData) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/veterinarios/perfil`, {
      method: "PUT",
      headers,
      body: JSON.stringify(perfilData),
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al guardar perfil profesional" };
    }
    return data;
  } catch (error) {
    console.error("Error guardarPerfilProfesional =>", error);
    return { error: "Error de conexión" };
  }
};

// ============ PANEL DE SEGUIMIENTO ============

/**
 * Obtiene datos de seguimiento de pacientes para el veterinario
 * @param {string} vetId - ID del veterinario
 * @param {number} [meses=3] - Período de tiempo en meses (1, 3, 6, 12)
 * @returns {Object} { data: { proximasCitas, citasCanceladas, pacientesSinRegresar, resumen } }
 */
export const obtenerDatosSeguimiento = async (vetId, meses = 3) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/veterinarios/${vetId}/seguimiento?meses=${meses}`, {
      method: "GET",
      headers,
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al obtener datos de seguimiento" };
    }
    return data;
  } catch (error) {
    console.error("Error obtenerDatosSeguimiento =>", error);
    return { error: "Error de conexión" };
  }
};

/**
 * Propone una cita al dueño de la mascota (desde panel de seguimiento)
 * @param {string} vetId - ID del veterinario
 * @param {Object} citaData - Datos de la cita propuesta
 * @returns {Object} { data: CitaPropuesta } o { error: string }
 */
export const proponerCitaDeVet = async (vetId, citaData) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/veterinarios/${vetId}/citas/proponer`, {
      method: "POST",
      headers,
      body: JSON.stringify(citaData),
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al proponer cita" };
    }
    return data;
  } catch (error) {
    console.error("Error proponerCitaDeVet =>", error);
    return { error: "Error de conexión" };
  }
};

// ============ CITAS PROPUESTAS PARA DUEÑOS ============

/**
 * Obtiene citas pendientes de confirmación para el dueño
 * @param {string} userId - ID del usuario/dueño
 * @returns {Object} { data: citasPendientes[] } o { error: string }
 */
export const obtenerCitasPendientes = async (userId) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/usuarios/${userId}/citas-pendientes`, {
      method: "GET",
      headers,
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al obtener citas pendientes" };
    }
    return data;
  } catch (error) {
    console.error("Error obtenerCitasPendientes =>", error);
    return { error: "Error de conexión" };
  }
};

/**
 * El dueño confirma una cita propuesta por el veterinario
 * @param {string} userId - ID del usuario/dueño
 * @param {string} citaId - ID de la cita
 * @param {string} vetId - ID del veterinario
 * @returns {Object} { data: citaActualizada } o { error: string }
 */
export const confirmarCitaPropuesta = async (userId, citaId, vetId) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/usuarios/${userId}/citas/${citaId}/confirmar`, {
      method: "POST",
      headers,
      body: JSON.stringify({ vetId }),
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al confirmar cita" };
    }
    return data;
  } catch (error) {
    console.error("Error confirmarCitaPropuesta =>", error);
    return { error: "Error de conexión" };
  }
};

/**
 * El dueño rechaza una cita propuesta por el veterinario
 * @param {string} userId - ID del usuario/dueño
 * @param {string} citaId - ID de la cita
 * @param {string} vetId - ID del veterinario
 * @param {string} [motivo] - Motivo del rechazo (opcional)
 * @returns {Object} { data: citaActualizada } o { error: string }
 */
export const rechazarCitaPropuesta = async (userId, citaId, vetId, motivo = "") => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/usuarios/${userId}/citas/${citaId}/rechazar`, {
      method: "POST",
      headers,
      body: JSON.stringify({ vetId, motivo }),
    });
    const data = await resp.json();
    if (!resp.ok) {
      return { error: data.error || "Error al rechazar cita" };
    }
    return data;
  } catch (error) {
    console.error("Error rechazarCitaPropuesta =>", error);
    return { error: "Error de conexión" };
  }
};

// ============ RECORDATORIOS DE CITAS PERSONALES ============

export const obtenerRecordatoriosCitas = async (userId) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/usuarios/${userId}/recordatorios-citas`, {
      headers
    });
    const data = await resp.json();
    if (!resp.ok) return { error: data.error || "Error al obtener recordatorios" };
    return data;
  } catch (error) {
    console.error("Error obtenerRecordatoriosCitas =>", error);
    return { error: "Error de conexión" };
  }
};

export const crearRecordatorioCita = async (userId, recordatorio) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/usuarios/${userId}/recordatorios-citas`, {
      method: "POST",
      headers,
      body: JSON.stringify(recordatorio),
    });
    const data = await resp.json();
    if (!resp.ok) return { error: data.error || "Error al crear recordatorio" };
    return data;
  } catch (error) {
    console.error("Error crearRecordatorioCita =>", error);
    return { error: "Error de conexión" };
  }
};

export const eliminarRecordatorioCita = async (userId, recordatorioId) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/usuarios/${userId}/recordatorios-citas/${recordatorioId}`, {
      method: "DELETE",
      headers,
    });
    const data = await resp.json();
    if (!resp.ok) return { error: data.error || "Error al eliminar recordatorio" };
    return data;
  } catch (error) {
    console.error("Error eliminarRecordatorioCita =>", error);
    return { error: "Error de conexión" };
  }
};

// ============ RECORDATORIOS PERSONALES (para Próximas) ============

export const obtenerRecordatoriosPersonales = async (objetoId) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/objetos/${objetoId}/recordatorios-personales`, {
      method: "GET",
      headers,
    });
    const data = await resp.json();
    if (!resp.ok) return { error: data.error || "Error al obtener recordatorios" };
    return { data: data.data || [] };
  } catch (error) {
    console.error("Error obtenerRecordatoriosPersonales =>", error);
    return { error: "Error de conexión" };
  }
};

export const crearRecordatorioPersonal = async (objetoId, datos) => {
  try {
    const headers = await getAuthHeaders();
    const resp = await fetchWrapper(`${API_URL}/api/objetos/${objetoId}/recordatorio-personal`, {
      method: "POST",
      headers,
      body: JSON.stringify(datos),
    });
    const data = await resp.json();
    if (!resp.ok) return { error: data.error || "Error al crear recordatorio" };
    return { data: data.data || data };
  } catch (error) {
    console.error("Error crearRecordatorioPersonal =>", error);
    return { error: "Error de conexión" };
  }
};